import React, { useRef } from 'react';
interface FileUploaderProps {
  trigger: React.ReactNode;
  onFileSelect: (files: File[]) => void;
  accept?: string;
  multiple?: boolean;
}

export const FileUploader: React.FC<FileUploaderProps> = ({
  trigger,
  onFileSelect,
  accept = '*',
  multiple = true,
}) => {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleButtonClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  const handleFileChange = (event) => {
    if (event.target.files.length > 0 && onFileSelect) {
      onFileSelect(Array.from(event.target.files));
      event.target.value = ''; // reset
    }
  };

  return (
    <div onClick={handleButtonClick}>
      {trigger}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: 'none' }}
        accept={accept}
        onChange={handleFileChange}
        multiple={multiple}
      />
    </div>
  );
};

export default FileUploader;
